import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
/** @public */ export const appStoreProductProps = {
    product_identifier: T.string
};
export const isAppStoreProduct = (product)=>{
    if (!product) return false;
    if (product.typeName !== "product") return false;
    return product.type === "APP_STORE";
};
export const isAppStoreProductId = (id)=>{
    if (!id) return false;
    return id.startsWith("product:APP_STORE:");
};
// Build the unique identifier for the product
export const appStoreIdentifierFromProps = (props)=>{
    return props.product_identifier;
};
/** @internal */ export const APP_STOREProductMigrations = defineMigrations({});
export const SWAppStoreProductInfo = {
    migrations: APP_STOREProductMigrations,
    props: appStoreProductProps,
    meta: {}
};
